var RecentLocations, RecentSearches, allTranslations, createBloodhoundTag, deEmphasis, getAutocompleteList, getHeadingPartial, getRecentSearches, getSubCategoryCollection, getTranslations, matchListItem, moveAutocomplete, normalizeQuery, partialAutocompleteList, partialCurrentLocation, partialLocationHelper, partialRecentSearchesList, partialSearchCategories, partialSearchCategoryList, prepareBloodhoundTag, removeRecentSearches, saveRecentSearch, setRecentSearches, setTranslations, templateAttributesForSubcategories, toCamelCase,
  slice = [].slice;

normalizeQuery = require('./m_normalizeQuery');

toCamelCase = require('../../../../../src/helpers/camelCase').toCamelCase;


/*
 * @type {Object} allTranslations Global closure to cache translations
 */

allTranslations = {};


/*
 * @type {Array} RecentSearches Global closure to cache recent searches terms
 */

RecentSearches = [];


/*
 * @type {Array} RecentLocations Global closure to cache recent location searches
 */

RecentLocations = [];


/*
 * Injects html tags to separate the neighborhood and the city
 *
 * @param   {String} label - Location with strong tags
 * @returns {String}
 */

deEmphasis = function(label) {
  var res;
  res = label.split(/,(.+)?/);
  if (res.length < 2) {
    return label;
  }
  if (res[0].includes('</strong>') || res[1].includes('<strong>')) {
    res.splice(1, 0, '<em>');
  } else {
    res.splice(1, 0, '</strong><em><strong>');
  }
  res.splice(3, 0, '</em>');
  return res.join('');
};


/*
 * Generate basic bloodhound tag name
 *
 * @param   {String} [type]     - Name of the api / collection name
 * @param   {String} attributes
 * @returns {String} bhw        - Base bloodhound tag
 */

createBloodhoundTag = function(type) {
  var bhw;
  if (type == null) {
    type = '';
  }
  type = type.split('|').map(function(i) {
    return toCamelCase(i);
  }).join('');
  bhw = "TouchSearchCategory" + type;
  return bhw;
};


/*
 * Method to build general (deal|location) autocomplete partial
 *
 * @param   {Array}  collections           - List of items returned from autocomplete
 * @param   {String} normQuery             - Normalized term entered by user
 * @param   {Number} [indexShift]          - Shift the index e.g due to previously processed collection
 * @returns {Object} {list, index, prefix}
 */

partialAutocompleteList = function(collections, normQuery, indexShift) {
  var index, item, label, lat, len, list, lng, locationPartial, n, queryLength, template, value;
  if (indexShift == null) {
    indexShift = 0;
  }
  queryLength = normQuery.length + 2;
  len = collections.length - 1;
  index = -1;
  list = [];
  locationPartial = '';
  while (item = collections.shift()) {
    lat = item.lat, lng = item.lng, label = item.label, value = item.value;
    if (lat) {
      locationPartial = " data-lat='" + lat + "' data-lng='" + lng + "'";
      if (item.neighborhood) {
        label = deEmphasis(label);
      }
    }
    n = len - collections.length;
    if (queryLength >= value.length && normQuery === normalizeQuery(value)) {
      index = n + indexShift;
    }
    template = "<li role='listitem' class='tw-item'>\n<a class='tw-link' id='tw" + n + "' tabindex='0' data-bhc='result-" + n + ":" + value + "' data-value='" + value + "'" + locationPartial + ">" + label + "</a>\n</li>";
    list.push(template);
  }
  return {
    list: list,
    index: index,
    prefix: 'tw'
  };
};


/*
 * LS-2211 current location / geolocation
 * Adds geolocation partial and handles matching
 *
 * @param   {String} widget         - Widget name
 * @param   {String} normQuery      - Normalized term user entered
 * @param   {Number} index          - Matched item index
 * @param   {Object} [translations] - Optional translation
 * @returns {Object} {list, index}
 */

partialCurrentLocation = function(widget, normQuery, index, translations) {
  var list, normLabel, template;
  if (translations == null) {
    translations = allTranslations;
  }
  normLabel = normalizeQuery(translations.search.currentlocation);
  template = "<li role='listitem'>\n<a class='current-location icon-compass-needle tw-link' tabindex='0' data-value='" + translations.search.currentlocation + "' data-bhw='" + widget + "'>" + translations.search.currentlocation + "</a>\n</li>";
  list = [template];
  if (index > -1) {
    index = index + 1;
  }
  if (normQuery === normLabel) {
    index = index + 1;
  }
  return {
    list: list,
    index: index
  };
};


/*
 * LS-2685 Location Helper message
 * Adds message to help users when searching locations
 *
 * @param   {Object} [translations] - Optional translation
 * @returns {Array}
 */

partialLocationHelper = function(translations) {
  var template, text;
  if (translations == null) {
    translations = allTranslations;
  }
  text = translations.search.helpermsg;
  template = "<li role='listitem'>\n<span class='tw-msg ls-location-helper'><span class=\"new-badge\">NEW</span>" + text + "</span>\n</li>";
  return [template];
};


/*
 * Adds recent searches partial
 *
 * @param   {String} widget         - Widget name
 * @param   {Array}  collection     - List of items to build recent searches widget
 * @param   {Object} [translations] - Optional translation
 * @returns {Object} {list, prefix}
 */

partialRecentSearchesList = function(widget, collection, translations) {
  var address, bhc, division, item, lat, list, lng, n, template, text;
  if (translations == null) {
    translations = allTranslations;
  }
  list = [];
  text = '';
  n = 0;
  switch (widget) {
    case 'recentSearches':
      text = translations.search.recentdeals;
      while (item = collection.shift()) {
        bhc = prepareBloodhoundTag(item);
        template = "<li role='listitem' class='tw-item tw-recent'>\n<a class='tw-link' id='twr" + n + "' tabindex='0' data-bhc='" + widget + ":" + bhc + "' data-value='" + item + "'>" + item + "</a>\n</li>";
        list.push(template);
        n++;
      }
      break;
    case 'recentLocations':
      text = translations.search.recentlocations;
      while (item = collection.shift()) {
        lat = item.lat, lng = item.lng, address = item.address, division = item.division;
        bhc = prepareBloodhoundTag(address);
        division = division ? "data-division='" + division + "'" : '';
        template = "<li role='listitem' class='tw-item tw-recent'>\n<a class='tw-link' id='twr" + n + "' tabindex='0' data-bhc='" + widget + ":" + bhc + "' data-lat='" + lat + "' data-lng='" + lng + "' data-value='" + address + "' " + division + ">" + address + "</a>\n</li>";
        list.push(template);
        n++;
      }
  }
  if (list.length) {
    list.unshift("<li class='ls-deal-widget-heading tw-recent'>" + text + "</li>");
  }
  return {
    list: list,
    prefix: 'twr'
  };
};


/*
 * Build L1 Category header partial
 *
 * @param   {String}  type           - category type
 * @param   {Object}  [translations] - Optional translation
 * @returns {String}  partial        - HTML partial containing L0 category heading
 */

getHeadingPartial = function(type, translations) {
  var partial, ref, txt;
  if (translations == null) {
    if (!Object.keys(allTranslations).length) {
      setTranslations((ref = Groupon.LS) != null ? ref.translations : void 0);
    }
    translations = allTranslations;
  }
  partial = '';
  txt = translations != null ? translations.categories[type] : void 0;
  return partial = txt ? "<div class='ls-deal-widget-heading tw-" + type + "'>" + txt + "</div>" : '';
};

templateAttributesForSubcategories = function() {
  var args, ariaAttributes, ariaListAttributes, bhw, catInfo, htmlCloseTag, htmlOpenTag, id, menuID, prefix, sectionID;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  id = args[0], sectionID = args[1], prefix = args[2], bhw = args[3];
  htmlOpenTag = 'span class="icon-plus tw-caption"';
  htmlCloseTag = 'span';
  menuID = prefix + "tw-" + id + "-menu";
  ariaAttributes = " role='link' aria-controls='" + menuID + "' aria-owns='" + menuID + "' aria-haspopup='true' ";
  catInfo = " cat='" + id + "' cat-path='" + sectionID + "|" + id + "'";
  ariaListAttributes = ' aria-live="polite"';
  return [htmlOpenTag, htmlCloseTag, ariaAttributes, ariaListAttributes, catInfo];
};


/*
 * Build Category partial
 *
 * @param   {Array}   collection - List of items
 * @param   {String}  sectionID  - category section name
 * @param   {Number}  [level]    - Optional parameter representing the taxonomy
 * @param   {Number}  [prefix]   - Optional prefix for id generation
 * @returns {String}             - HTML String
 */

partialSearchCategoryList = function(collection, sectionID, level, prefix, m2016) {
  var ariaAttributes, ariaListAttributes, attributes, baseBHW, baseObject, baseUrl, bhw, catInfo, count, countString, friendlyName, htmlCloseTag, htmlOpenTag, id, item, list, menuID, newBadge, newBadgeTag, newBadgeTxt, subcategories, template, url;
  if (level == null) {
    level = 1;
  }
  if (prefix == null) {
    prefix = '';
  }
  if (m2016 == null) {
    m2016 = true;
  }
  if (!(collection != null ? collection.length : void 0)) {
    return '';
  }
  list = [];
  url = '';
  baseBHW = createBloodhoundTag(sectionID);
  baseObject = collection.shift();
  baseUrl = baseObject.baseUrl;
  if (!baseUrl) {
    baseUrl = false;
    collection.unshift(baseObject);
  }
  while (item = collection.shift()) {

    /*
     * item can be either of type "Array" or "Object"
     * API facets are normally mapped as arrays
     * while config or constructed entries (all deals) ar
     * mapped as object.
     */
    if (Array.isArray(item)) {
      if (!baseUrl) {
        continue;
      }
      id = item[0], friendlyName = item[1], count = item[2], subcategories = item[3];
      url = baseUrl + id;
    } else {
      id = item.i, friendlyName = item.n, count = item.c, subcategories = item.s, url = item.u, newBadge = item.newBadge;
    }
    ariaAttributes = ariaListAttributes = catInfo = newBadgeTag = '';
    countString = count ? " <span class='tw-count'>(" + count + ")</span>" : '';
    bhw = id ? baseBHW + toCamelCase(id) : baseBHW + 'AllDeal';
    if (newBadge && (newBadgeTxt = allTranslations.general.newbadge)) {
      newBadgeTag = "<span class='new-badge'>" + newBadgeTxt + "</span>";
    }
    if (subcategories != null ? subcategories.length : void 0) {
      attributes = templateAttributesForSubcategories(id, sectionID, prefix, bhw);
      htmlOpenTag = attributes[0], htmlCloseTag = attributes[1], ariaAttributes = attributes[2], ariaListAttributes = attributes[3], catInfo = attributes[4];
    } else {
      url = url ? "href='" + url + "' " : '';
      htmlOpenTag = "a " + url + "class='tw-link'";
      htmlCloseTag = 'a';
    }
    template = "<li class='tw-item tw-cat-item tw-cat-L" + level + "'" + ariaListAttributes + ">\n<" + htmlOpenTag + " data-bhw='" + bhw + "' " + catInfo + " " + ariaAttributes + ">" + newBadgeTag + friendlyName + countString + "</" + htmlCloseTag + ">\n</li>";
    list.push(template);
  }
  if (list.length) {
    menuID = sectionID.split('|').pop();
    list.unshift("<ul id='" + prefix + "tw-" + menuID + "-menu' class='tw-cat-menu tw-cat-menu-L" + level + "'>");
    list.push("</ul>");
  }
  return list.join('');
};


/*
 * Build Category lists and wrap them
 *
 * @param   {Array}   collections    - List of items
 * @param   {Array}   [prefix]       - Prefix for id generation (Optional)
 * @param   {Boolean} [m2016]        - Mobile2016 flag (Optional)
 * @returns {Object}  {list[]}       - List of categories
 */

partialSearchCategories = function(collections, prefix, m2016) {
  var collection, heading, item, listItems, type;
  if (prefix == null) {
    prefix = '';
  }
  if (m2016 == null) {
    m2016 = true;
  }
  item = collections[0];
  listItems = [];
  for (type in item) {
    collection = item[type];
    if (collection != null ? collection.length : void 0) {
      heading = getHeadingPartial(type);
      listItems.push("<li id='" + prefix + "tw-" + type + "' class='tw-category'>" + heading);
      listItems.push(partialSearchCategoryList(collection.slice(0), type, 1, prefix, m2016));
      listItems.push("</li>");
    }
  }
  return {
    list: listItems
  };
};


/*
 * Global method to generate the autocomplete list
 *
 * @param   {Array}  collections               - List of collections to process
 * @param   {String} query                     - Term entered by user
 * @param   {Object} [translations]            - Optional translation
 * @returns {Object} {list, index, bh, prefix}
 */

getAutocompleteList = function(collections, query) {
  var bh, data, finalList, index, indexShift, j, len1, list, normQuery, prefix, ref, ref1, ref2, ref3, ref4, ref5, tempList, widget;
  tempList = [];
  index = -1;
  indexShift = 0;
  prefix = '';
  normQuery = normalizeQuery(query);
  for (j = 0, len1 = collections.length; j < len1; j++) {
    ref = collections[j], data = ref.collection, widget = ref.widget;
    switch (widget) {
      case 'autocomplete':
        if (query) {
          ref1 = partialAutocompleteList(data, normQuery, indexShift), list = ref1.list, index = ref1.index, prefix = ref1.prefix;
        }
        break;
      case 'helperMessage':
        list = partialLocationHelper();
        break;
      case 'geolocation':
        ref2 = partialCurrentLocation(widget, normQuery, index), list = ref2.list, index = ref2.index;
        indexShift += list.length;
        break;
      case 'recentLocations':
        ref3 = partialRecentSearchesList(widget, data), list = ref3.list, prefix = ref3.prefix;
        break;
      case 'recentSearches':
        ref4 = partialRecentSearchesList(widget, data), list = ref4.list, prefix = ref4.prefix;
        break;
      case 'searchCategories':
        list = partialSearchCategories(data).list;
    }
    tempList.push.apply(tempList, list);
  }
  bh = widget === 'autocomplete' ? {
    type: 'bhc',
    val: "UserTyped:" + query
  } : {
    type: 'bhw',
    val: toCamelCase(widget)
  };
  ref5 = matchListItem(tempList, index), finalList = ref5.list, index = ref5.index;
  return {
    list: finalList,
    index: index,
    bh: bh,
    prefix: prefix
  };
};


/*
 * Get translations
 *
 * @param   {String} key
 * @returns {Object}
 */

getTranslations = function(key) {
  return allTranslations[key] || {};
};


/*
 * Returns list of recent searches queries retrieved from localStorage
 *
 * param    {String} - Input type
 * @returns {Array}  - list
 */

getRecentSearches = function(type) {
  var list, ref, ref1;
  if (type == null) {
    type = 'deal';
  }
  list = [];
  try {
    switch (type) {
      case 'deal':
        list = JSON.parse(((ref = window.localStorage) != null ? ref.getItem('LS_recentSearches') : void 0) || '[]');
        break;
      case 'location':
        list = JSON.parse(((ref1 = window.localStorage) != null ? ref1.getItem('LS_recentLocations') : void 0) || '[]');
    }
  } catch (error) {}
  return list;
};


/*
 * Sets matching classes to list item when match indicated
 *
 * @param   {Array}  list          - List of items
 * @param   {Number} index         - Index of the item in the list that matched query
 * @returns {Object} {list, index}
 */

matchListItem = function(list, index) {
  var partial;
  if (index > -1) {
    partial = "<a class='typeahead-match typeahead-match-highlight";
    if (list[index].match(/<a class='/)) {
      list[index] = list[index].replace(/<a class='/, partial + " ");
    } else {
      list[index] = list[index].replace(/<a/, partial + "'");
    }
  }
  return {
    list: list,
    index: index
  };
};


/*
 * Move typeahead container into its context.
 * This is only needed for desktop
 *
 * @param {Object} $container - Selector for typeahead wrapper
 * @param {String} ctx        - Typeahead context
 * @param {String} env        - Environment
 */

moveAutocomplete = function($container, ctx, env) {
  var selector;
  if (env === 'desktop') {
    switch (ctx) {
      case 'search':
        selector = '.deal-search';
        break;
      case 'location':
        selector = '.location-search';
    }
    $(selector).append($container);
  }
};


/*
 * Returns Bloodhound tag name
 *
 * @param   {String|Object} value
 * @returns {String}        tag
 */

prepareBloodhoundTag = function(value) {
  var address, division, tag;
  tag = '';
  if (!value) {
    return tag;
  }
  if (typeof value === 'string') {
    tag = value;
  }
  if (typeof value === 'object') {
    division = value.division, address = value.address;
    tag = address || division;
  }
  if (typeof tag === 'string') {
    tag = tag.toLowerCase().replace(/[^\w\d]+/g, '_');
  }
  return tag;
};


/*
 * Helper function to remove stored searches
 *
 * @param {String} type - Input type
 */

removeRecentSearches = function(type) {
  if (type == null) {
    type = 'deal';
  }
  switch (type) {
    case 'deal':
      window.localStorage.removeItem('LS_recentSearches');
      RecentSearches = [];
      break;
    case 'location':
      window.localStorage.removeItem('LS_recentLocations');
      RecentLocations = [];
  }
};


/*
 * Saves recent searches array as string in localStorage
 *
 * @param {Array}  keywords - List of keywords searched by user
 * @param {String} type     - input type
 */

setRecentSearches = function(keywords, type) {
  var key, ref;
  switch (type) {
    case 'deal':
      key = 'LS_recentSearches';
      break;
    case 'location':
      key = 'LS_recentLocations';
  }
  try {
    return (ref = window.localStorage) != null ? ref.setItem(key, JSON.stringify(keywords)) : void 0;
  } catch (error) {}
};


/*
 * Convert, prepend and save term to recent searches list
 *
 * @param {String} term - Deal query entered by user
 * @param {String} type - input type (Optional)
 * @param {String} env  - Environment. Controls amount of items (Optional)
 */

saveRecentSearch = function(term, type, env) {
  var amount, index, keywords;
  if (type == null) {
    type = 'deal';
  }
  if (env == null) {
    env = 'desktop';
  }
  amount = type === 'deal' && env === 'mobile' ? 5 : 10;
  keywords = getRecentSearches(type) || [];
  switch (typeof term) {
    case 'string':
      term = _.escape(term).trim().toLowerCase();
      if (term === '') {
        return;
      }
      index = keywords.findIndex(function(e) {
        return e === term;
      });
      break;
    case 'object':
      index = keywords.findIndex(function(e) {
        return e.division === term.division;
      });
  }
  if (index > -1) {
    keywords.move(index, 0);
  } else {
    keywords.unshift(term);
  }
  setRecentSearches(keywords.slice(0, amount), type);
};


/*
 * Cache translations globally
 *
 * @param {Object} translations
 */

setTranslations = function(translations) {
  allTranslations = translations;
};


/*
 * Get subcategory collection and its taxonomy level
 *
 * @param   {Array}                            collections
 * @param   {Array}                            path
 * @param   {Number}                           [level] - Taxonomy level
 * @returns {{collection.Array, level.Number}}
 */

getSubCategoryCollection = function(collections, path, level) {
  var collection, findSubCategory, id, temp;
  if (level == null) {
    level = 1;
  }
  collection = collections;
  id = void 0;

  /*
   * Condition to find matching item with categories
   * Checks if ID (i) matches and if subcategories (s) exists
   *
   * @param   {Object} item  - Array item
   * @returns {Boolean}      - Condition being passed to Array.prototype.find() to return object
   */
  findSubCategory = function(item) {
    var ref;
    return item[0] === id && ((ref = item[3]) != null ? ref.length : void 0);
  };

  /*
   * NOTE: This might be more efficient with Array::reduce
  
    findSubCategory = (item) ->
      if item[0] is id and item[3]?.length
        return item[3]
    level++ if (collection = collection.reduce(findSubCategory))
   */
  while (id = path.shift()) {
    if (temp = collection.find(findSubCategory)) {
      collection = temp[3].slice(0);
      level++;
    }
  }
  return {
    collection: collection,
    level: level
  };
};

module.exports = {
  createBloodhoundTag: createBloodhoundTag,
  getAutocompleteList: getAutocompleteList,
  getHeadingPartial: getHeadingPartial,
  getRecentSearches: getRecentSearches,
  getSubCategoryCollection: getSubCategoryCollection,
  getTranslations: getTranslations,
  deEmphasis: deEmphasis,
  matchListItem: matchListItem,
  moveAutocomplete: moveAutocomplete,
  partialAutocompleteList: partialAutocompleteList,
  partialCurrentLocation: partialCurrentLocation,
  partialLocationHelper: partialLocationHelper,
  partialRecentSearchesList: partialRecentSearchesList,
  partialSearchCategories: partialSearchCategories,
  partialSearchCategoryList: partialSearchCategoryList,
  prepareBloodhoundTag: prepareBloodhoundTag,
  removeRecentSearches: removeRecentSearches,
  saveRecentSearch: saveRecentSearch,
  setRecentSearches: setRecentSearches,
  setTranslations: setTranslations,
  templateAttributesForSubcategories: templateAttributesForSubcategories
};

//# sourceMappingURL=data:application/json;base64,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
